export const SET_AUTHENTICATED_STATUS = "SET_AUTHENTICATED_STATUS"
export const SET_USERNAME = "SET_USERNAME"
export const SET_ROLES = "SET_ROLES"
export const SET_LOBBYIST_ID = "SET_LOBBYIST_ID"
export const CHECKED_FOR_USER_TOKEN = "CHECKED_FOR_USER_TOKEN"
export const GET_CHANGE_PASSWORD_DETAILS = "GET_CHANGE_PASSWORD_DETAILS"
export const LOGOUT = "LOGOUT"
export const SESSION_TIMED_OUT = "SESSION_TIMED_OUT"
export const CLEAR_SESSION_TIMED_OUT = "CLEAR_SESSION_TIMED_OUT"


// WEBPACK FOOTER //
// ./src/actionTypes/auth.js